<template>
	<div>
		<myheader headTitle="CA证书"></myheader>
		<div class="header_extend_main" style="padding-bottom: .5rem;">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card" style="padding:.5rem;">
					<div style="border:1px solid #ccc;border-radius: .3rem;">
						<div style="padding: 1rem .5rem;">
							<div class="all_text_center">
								<img src="@/assets/images/selected.svg" style="width:4rem;heiht:4rem" />
								<div class="text16 textcolorblack font_weight_bold margin_top_8">国富安数字证书</div>
							</div>
							<!-- 		<div class="text14 textcolor999 margin_top_10">颁发给</div>
							<div class="text14 textcolor333 margin_top_3">{{$store.state.certInfo.corpName}}</div>
							<div class="text14 textcolor999 margin_top_10">序列号</div>
							<div class="text14 textcolor333 margin_top_3">{{$store.state.certInfo.sn}}</div>
							<div class="text14 textcolor999 margin_top_10">证书主题</div>
							<div class="text14 textcolor333 margin_top_3" style="white-space: pre-wrap">
								{{$store.state.certInfo.subject.replaceAll(',', ',\r\n')}}
							</div>
							<div class="text14 textcolor999 margin_top_10">证书颁发者</div>
							<div class="text14 textcolor333 margin_top_3">{{$store.state.certInfo.from}}</div>
							<div class="text14 textcolor999 margin_top_10">起始时间</div>
							<div class="text14 textcolor333 margin_top_3">{{$store.state.certInfo.issueDate}}</div>
							<div class="text14 textcolor999 margin_top_10">结束时间</div>
							<div class="text14 textcolor333 margin_top_3">{{$store.state.certInfo.expireDate}}</div> -->
							<div class="horizontal_line margin_top_10" style="background-color: #ccc;"></div>
							<div v-if="item">
								<div class="text14 textcolor999 margin_top_10">颁发给</div>
								<div class="text14 textcolor333 margin_top_3">{{item.corpName}}</div>
								<div class="text14 textcolor999 margin_top_10">序列号</div>
								<div class="text14 textcolor333 margin_top_3">{{item.sn}}</div>
								<div class="text14 textcolor999 margin_top_10">证书主题</div>
								<div class="text14 textcolor333 margin_top_3" style="white-space: pre-wrap">
									{{item.subject.replaceAll(',', ',\r\n').trim()}}
								</div>
								<div class="text14 textcolor999 margin_top_10">证书颁发者</div>
								<div class="text14 textcolor333 margin_top_3">{{item.from}}</div>
								<div class="text14 textcolor999 margin_top_10">起始时间</div>
								<div class="text14 textcolor333 margin_top_3">{{item.issueDate}}</div>
								<div class="text14 textcolor999 margin_top_10">结束时间</div>
								<div class="text14 textcolor333 margin_top_3">{{item.expireDate}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getLocalCertList,
	} from '../../utils/nativeCertSign.js';
	import {
		getDeviceType,
	} from '../../utils/nativeOtherOperate.js';
	export default {
		data() {
			return {
				//用户名
				userName: this.$store.state.loginInfo.userName,
				//
				certSn: '',
				//
				item: '',
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			//
			getLocalCertList(){
				this.$store.dispatch(this.$LoadShow, true)
				getLocalCertList(this.userName).then(res=>{
					if (res) {
						let list = JSON.parse(res)
						this.getLocalItem(list)
					} else {
						this.$Toast('未获取到证书列表信息，请重试！')
					}
				}).finally(()=>{
					this.$store.dispatch(this.$LoadShow, false)
				})
			},
			//获取本地证书列表
			getLocalItem(list) {
				//console.log('certSn=',this.certSn)
				//console.log('list-=',list)
				if (list && Array.isArray(list) && list.length > 0) {
					//企业证书列表
					let itemlist = list.filter(item => {
						return item.sn === this.certSn;
					});
					if (itemlist && Array.isArray(itemlist) && itemlist.length > 0) {
						this.item = itemlist[0]
						if (getDeviceType() === 'ios') {
							this.item.subject = decodeURIComponent(this.item.subject.replace(/\\x/g, '%'))
							//console.log('ios-item.subject=', this.item.subject)
						}
						// else if(window.plus && plus.os.name === 'Android'){
						// 	this.item.subject = this.item.subject.replace('\\', '')
						// }
						else {
							this.item.subject = this.item.subject.replace('\\', '')
							//item.subject = decodeURIComponent(item.subject.replace(/\\x/g, '%'))
							//console.log(item.subject)
							//console.log(decodeURIComponent(item.subject.replace(/\x/g, '%')))
							//item.subject = decodeURIComponent(item.subject.replace(/\\x/g, '%'))
						}
						// if (plus.os.name === 'iOS') {
						// 	this.item.subject = decodeURIComponent(this.item.subject.replace(/\\x/g, '%'))
						// 	//console.log('ios-item.subject=', this.item.subject)
						// } else {
						// 	//item.subject = decodeURIComponent(item.subject.replace(/\\x/g, '%'))
						// 	this.item.subject = this.item.subject.replace('\\', '')
						// }
						let content = this.item.subject.split(',')
						for (let k of content) {
							if (k.indexOf('CN=') == 0) {
								this.item.corpName = k.substring(3, k.length)
								if (this.item.corpName === 'Dongsheng Petroleum (Mongolia)CO.') {
									this.item.corpName = 'Dongsheng Petroleum (Mongolia)CO.,LTD'
								}
							}
							if (k.indexOf('C=') == 0) {
								if (k.substring(2, k.length) === 'CN') {
									this.item.from = 'CN=Demo_RSASign'
								} else {
									this.item.from = k.substring(2, k.length)
								}
							}
						}
						let issur = this.item.issuer.split(',')
						for (let i of issur) {
							if (i.indexOf('CN=') === 0) {
								this.item.from = i.substring(3, i.length)
							}
						}
						//ios
						if (getDeviceType() === 'ios') {
							this.item.expireDate = this.Tool.dateFormate(this.Tool.getDateForUtc(this.item.expireDate))
							this.item.issueDate = this.Tool.dateFormate(this.Tool.getDateForUtc(this.item.issueDate))
						} else if (getDeviceType() === 'android') {

						} else {
							this.item.expireDate = this.Tool.dateFormate(this.item.expireDate)
							this.item.issueDate = this.Tool.dateFormate(this.item.issueDate)
						}
					} else {
						this.$Toast('未获取到证书信息，请退出重试！')
					}
				} else {
					this.$Toast('未获取到证书列表信息，请退出重试！')
				}
			},
			init() {
				this.certSn = this.$route.query.certSn
				this.getLocalCertList()
			},
		},
	};
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";
</style>